import React from 'react';
import { marked } from 'marked';

export const getNoteText = (text, createdBy = null, disclaimer = '') => {
  if (createdBy === 'AppWork AI - BETA' && disclaimer !== '') {
    const mainText = `<div class="parsedMarkdown">${marked.parse(text)}</div>`;
    const styledDisclaimer = `<p style="margin-bottom: 16px; color: #666;"><em style="font-style: italic !important;">${disclaimer}</em></p>`;
    const fullContent = `${styledDisclaimer} ${mainText}`;
    return <div dangerouslySetInnerHTML={{ __html: displayMatches(fullContent) }}></div>;
  }
  return <div dangerouslySetInnerHTML={{ __html: displayMatches(displayUrlInUserComments(text)) }}></div>;
};

const displayMatches = (text) => {
  var regex = new RegExp(/(\@\[).+?([0-9]+\))/, 'gi');
  var response = text
    ?.replace(regex, function (str) {
      // const id = str.split('(')[1].split(')')[0];
      const name = str.split('[')[1].split(']')[0];
      return `<span>${name}</span>`;
    })
    .replace('(Deleted)', `<div class="italic">Removed</div>`);

  return response || '';
};

export function displayUrlInUserComments(text) {
  var urlRegex = /(((https?:\/\/)|(www\.))?(?:([a-z,0-9]+\.[a-z,A-z,0-9])+)[^\s]+)/gi;
  // var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/ig;
  //var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text?.replace(urlRegex, function (url, b, c) {
    var url2 = c == 'www.' || c == undefined ? 'http://' + url : url;
    return '<a style="color:#1aaa60" href="' + url2 + '" target="_blank">' + url + '</a>';
  });
}
